// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text-muted{color:#9b9b9b}.vx-sidebar__container{margin-top:12rem}.react-geocoder{width:30rem;margin:5rem auto}.react-geocoder input{width:100%}.react-geocoder-results{position:absolute;top:18.5rem;left:6rem;z-index:5;background-color:white;border:1px solid black;width:100%;max-width:30rem}.react-geocoder-item{cursor:pointer;border-bottom:1px solid black;padding:0.3rem}.react-geocoder-item:hover{background-color:rgba(169,204,255,0.753)}\n", ""]);
// Exports
module.exports = exports;
